// extracted by mini-css-extract-plugin
export var teamWrap = "our-team-module--teamWrap--uoo-O";